import React, { useEffect, useState } from 'react';
import './CharacterSprites.scss';
import { useSelector } from 'react-redux';
import TMNT from './Images/TMNT.png';

const getSpriteAsset = (characterName, isActive) => {
  const spriteVariant = isActive ? 'Color' : 'Grey';
  const spriteFileName = `${characterName} - ${spriteVariant}.png`;

  return require(`./Images/Turtle Sprites/${characterName}/${spriteFileName}`);
};

const CharacterSprites = () => {
  const [highlightedCharacters, setHighlightedCharacters] = useState([]);
  const [activeHighlightedCharacter, setActiveHighlightedCharacter] =
    useState(null);
  const stageListData = useSelector((state) => state.stageList.stageListData);

  const allCharacters = stageListData.flatMap((stage) => stage.characters);

  useEffect(() => {
    const handleRunStart = () => {
      setHighlightedCharacters([]);
      setActiveHighlightedCharacter(null);
    };

    const handleCharacterSpin = (event) => {
      const spinningCharacter = event.detail?.character;
      if (spinningCharacter) {
        setActiveHighlightedCharacter(spinningCharacter);
      }
    };

    const handleCharacterSelected = (event) => {
      const selectedCharacter = event.detail?.character;
      if (!selectedCharacter) {
        return;
      }

      setActiveHighlightedCharacter(selectedCharacter);
      setHighlightedCharacters((current) => {
        if (current.includes(selectedCharacter)) {
          return current;
        }

        return [...current, selectedCharacter];
      });
    };

    document.addEventListener('tmnt-character-run-start', handleRunStart);
    document.addEventListener('tmnt-character-spin', handleCharacterSpin);
    document.addEventListener(
      'tmnt-character-selected',
      handleCharacterSelected,
    );

    return () => {
      document.removeEventListener('tmnt-character-run-start', handleRunStart);
      document.removeEventListener('tmnt-character-spin', handleCharacterSpin);
      document.removeEventListener(
        'tmnt-character-selected',
        handleCharacterSelected,
      );
    };
  }, []);

  return (
    <div className='container-sprites'>
      <div className='character-sprites'>
        {allCharacters.map((character) => {
          const isHighlighted =
            activeHighlightedCharacter === character.character ||
            highlightedCharacters.includes(character.character);

          return (
            <img
              key={character.id}
              src={getSpriteAsset(character.character, character.isActive)}
              alt={character.character}
              className={`character-sprite-image ${character.character} ${
                isHighlighted ? 'character-sprites--highlighted' : ''
              }`}
            />
          );
        })}
      </div>
      <img src={TMNT} alt='TMNT Rescue Palooza' className='TMNT-Logo' />
    </div>
  );
};

export default CharacterSprites;
